module.exports = "/images/login-bg.jpg?4ba8a7e2dd968f5470b6383c3bf5d649";